import React from 'react';
import ReactDOM from 'react-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

import { initAuth } from './core/auth';
import { configureStore, history } from './core/store';
import Root from './views/root';
import './views/styles/styles.css';

const store = configureStore();
const rootElement = document.getElementById('root');

const render = RootComponent => {
  const theme = createMuiTheme({
    palette: {
      primary: blue,
    },
    typography: {
      useNextVariants: true,
      suppressDeprecationWarnings: false,
    },
  });

  ReactDOM.render(
    <MuiThemeProvider theme={theme}>
      <RootComponent history={history} store={store} />
    </MuiThemeProvider>,
    rootElement,
  );
};

initAuth(store.dispatch)
  .then(() => render(Root))
  .catch(error => console.error(error)); // eslint-disable-line no-console



// WEBPACK FOOTER //
// ./src/index.js